import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk-legacy/ui-react-utils';
import { View, StyleSheet } from 'react-native';
import { BasicNumber } from '@dbk/ui-numbers';
import { IntlProvider } from '@dbk/format';

import AssetItem from '../../../../../../../src/components/asset/asset-item';
import {
  AssetItemHeaderDescription,
} from '../../../../../../../src/components/asset/asset-item/asset-item-header';
import NavigationArrow from '../../../../../../../src/components/common/navigation-arrow';

import TableRow from '../../../../../../../src/components/common/table-row';
import SimpleDate from '../../../../../../../src/components/common/date';
import {
  AbbreviatedNumber,
  ChangeIndicatedAbbreviatedNumber,
} from '../../../../../../../src/components/common/number';
import Text from '../../../../../../../src/components/common/text';
import Link from '../../../../../../../src/components/common/link';
import styles from '../../positions-global/asset-position/asset-position.styles';
import { HorizontalDashes } from '../../../../../../../src/components/common/dashes';
import { SEPARATOR_STROKE , ASSET_TRADE_TYPE, PALETTE } from '../../../../../../../src/constants';
import { HighlightSearchText } from '../../../../../../../src/utils/HighlightSearchText';

function Transaction(props) {
  const { columnWidths, row, assetCategory, options, screen, labels, transact, messages, langCode, searchValue } = props;
  const {
    type,
    tradeNumber,
    valueDate,
    tradeDate,
    quantity,
    netAmount,
    purchasePrice,
    currency,
    securityLongName,
    tradeType,
    posDesc
  } = row;


  function toggleModal(pageType) {
    const { changePage, tradeNumber, valueDate, tradeDate, row, transact, messages } = props;
    const adviceItem = {
      tradeNo: row.tradeNumber,
    };

    transact.getAdvices({
      adviceItem
    });
  }


  function showAdviseLink() {
    const { messages } = props;
    if (assetCategory === 'equities' || assetCategory == 'bonds' || assetCategory == 'various' || assetCategory == 'optionsDerivatives' || assetCategory == 'alternatives' || assetCategory == 'cash') {
      return (
        <View>
          <HorizontalDashes stroke={SEPARATOR_STROKE} />
          <TableRow style={styles.bottomRow}>
            <div
              style={{ 'cursor': 'pointer' }}
              onClick={() => toggleModal('pdf')}
            >
              <Text>
                {messages[labels.seeAdvice]}
              </Text>
              <span className="arrowClass"><NavigationArrow /></span>
            </div>
          </TableRow>
        </View>
      )
    }
    return null;

  }

  function renderColumnValue(row, option) {
    const value = row[option.key];
    const { messages } = props;
    let align;

    if (option.type === 'date') {
      if (option.key === 'tradeDate') {
        align = 'left';
      } else {
        align = 'right';
      }
      return (
        <TableRow.Column
          align={align}
          width={option.width}
        >
          <SimpleDate value={value} 
            renderProps={{
              style: StyleSheet.flatten(styles.activeItem),
            }}
          />
        </TableRow.Column>
      );
    }

    if (option.type === 'currency') {
      return (
        <TableRow.Column width={option.width}>
          <ChangeIndicatedAbbreviatedNumber
            renderProps={{ size: 'normal' }}
            value={value}
            // maxDigits={8}
            renderExactAs="currency"
            onlyNegativeSign
          />
        </TableRow.Column>
      );
    }

    if (option.type === 'number') {
      const quantityArr = value && value.toString().split('.');
      const minDecimalReq = quantityArr && quantityArr.length > 1 ? quantityArr[1].length : 2;
      return (
        <TableRow.Column width={option.width} gutter={false}>
          <View style={styles.numberTx}>
            {/* <AbbreviatedNumber
                  renderProps={{ size: 'large' }}
                  // maxDigits={6}
                  maxDecimals={4}
                  maxDigitsIncludeDecimals={true}
                  value={value}
                /> */}

            <IntlProvider locale={langCode}>
              <BasicNumber
                value={value}
                minimumFractionDigits={minDecimalReq}
                renderProps={{
                  className: 'normal primary'
                }}
              />
            </IntlProvider>
          </View>
        </TableRow.Column>
      );
    }

    return (<TableRow.Column width={option.width}>
      <Text>{value}</Text>
    </TableRow.Column>
    )
  }

  if (transact.isEmpty) {
    transact.setIsEmpty(false);
    alert(messages['app.position.transDetails']);
  }

  if (!screen.isSmall) {
    return (
      <AssetItem>
        <TableRow style={styles.bottomRow}>
          {options.map(opt => renderColumnValue(row, opt, screen))}
        </TableRow>
        <TableRow style={styles.topRow}>
          <TableRow.Column
            align="left"
            testID="description"
          >
            <HighlightSearchText
              text={type && (type.substr(0, 1).toUpperCase() + type.substr(1))}
              highlight={searchValue}
              style={{ flexWrap: 'wrap' }}
              highlightStyle={{ color: PALETTE.highlightSearchText }}
            />
          </TableRow.Column>
        </TableRow>
        <TableRow style={styles.bottomRow}>
          <HighlightSearchText
            text={tradeType === ASSET_TRADE_TYPE.trade_type ? posDesc : securityLongName}
            highlight={searchValue}
            style={styles.securityColor}
            highlightStyle={{ color: PALETTE.highlightSearchText }}
          />
        </TableRow>      
        {
          showAdviseLink()
        }
      </AssetItem>
    );
  }
  return (
    <AssetItem>
      <TableRow style={styles.topRow}>
        <TableRow.Column
          align="left"
          testID="description"
        >
          <AssetItemHeaderDescription
            row={{
              description: <HighlightSearchText
                text={type && (type.substr(0, 1).toUpperCase() + type.substr(1))}
                highlight={searchValue}
                style={{ flexWrap: 'wrap' }}
                highlightStyle={{ color: PALETTE.highlightSearchText }}
              />,
            }}
          />
        </TableRow.Column>
      </TableRow>
      <TableRow style={styles.bottomRow}>
        {options.map(opt => {
          if (opt.isPhone == true) {
            return (renderColumnValue(row, opt, screen))
          }
          return null

        })
        }
      </TableRow>
    </AssetItem>
  );

}

Transaction.propTypes = {
  row: PropTypes.shape({
    type: PropTypes.string,
    quantity: PropTypes.number,
    netAmount: PropTypes.number,
    tradeDate: PropTypes.string,
  }),
  columnWidths: PropTypes.arrayOf(PropTypes.number),
  assetCategory: PropTypes.string,
  screen: PropTypes.shape({
    isSmall: PropTypes.bool
  }),
  labels: PropTypes.shape({
    seeAdvice: PropTypes.string,
  }),
  abbreviationRules: PropTypes.object,
};

export default pure(Transaction);
